import { replaceMaterialSnippets } from '#imports';

export const setupTextWrapMaterial = (shader, uniforms = {}) => {
    replaceMaterialSnippets({
        material: shader,
        uniforms: {
            uProgress: { value: 0 },
            uRadius: { value: 1 },
            ...uniforms,
        },
        vertex: [
            {
                snippet: 'attribute vec3 aTroikaGlyphColor;',
                newSnippet: /* glsl */ `
                        attribute vec3 aOffset;
                        attribute float aAlpha;
                        varying float vAlpha;
                        varying vec3 vTransformed;
                        varying float vArcAngle;

                        uniform float uProgress;
                        uniform float uRadius;
                    `,
            },
            {
                snippet: 'position.xy = mix(bounds.xy, bounds.zw, clippedXY);',
                newSnippet: /* glsl */ `
                    float uTextArcLength = uTroikaTotalBounds.z - uTroikaTotalBounds.x;

                    // Convert flat x layout into a cylindrical arc around the y-axis
                    float PI_2 = 6.28318530718;
                    float startOffset = -PI_2 * 1.25;
                    float endOffset = PI_2 * 0.25;
                    float revealAngle = mix(startOffset, endOffset, uProgress);
                    float arcAngle = (position.x - uTroikaTotalBounds.x) / uTextArcLength * PI_2; // full circle
                    float angle = arcAngle + revealAngle;
                    vArcAngle = angle;

                    // float arcProgress = (position.x - uTroikaTotalBounds.x) / uTextArcLength;
                    // float arcAngle = (arcProgress - 0.5) * PI2 + uRevealAngle;

                    float newX = sin(angle) * uRadius;
                    float newZ = cos(angle) * uRadius;

                    position.x = newX;
                    position.z = newZ;
                    normal.xz = vec2(sin(angle), -cos(angle));

                `,
            },
            {
                snippet: 'vec3 transformed = vec3( troika_position_1 );',
                newSnippet: /* glsl */ `
                        transformed += aOffset;
                        vAlpha = aAlpha;
                        vTransformed = transformed;
                    `,
            },
        ],
        fragment: [
            {
                snippet: 'varying vec3 vTroikaGlyphColor;',
                newSnippet: /* glsl */ `
                        varying float vAlpha;
                        varying vec3 vTransformed;
                        varying float vArcAngle;
                    `,
            },
            {
                snippet: 'gl_FragColor.a *= edgeAlpha;',
                newSnippet: /* glsl */ `
                        float PI_2 = 6.28318530718;
                        // float PI = 3.14159265359;
                        float visibleStart = -PI;
                        float visibleEnd = PI;
                        float arcAlpha = step(visibleStart, vArcAngle) * step(vArcAngle, visibleEnd);

                        if (arcAlpha <= 0.0) discard;


                        vec3 frontColor = vec3(1.0);
                        vec3 backsideColor = vec3(0.3);
                        gl_FragColor.rgb = gl_FrontFacing ? frontColor : backsideColor;
                        gl_FragColor.a *= vAlpha * arcAlpha;
                        
                    `,
            },
        ],
    });
};
